import React, { useState } from "react";

import PropTypes from "prop-types";
import useStyles from "@hooks/useStyles";
import Box from "@material-ui/core/Box";
import TextField from "@material-ui/core/TextField";
import Link from "@material-ui/core/Link";
import Button from "@material-ui/core/Button";
import Grid from "@material-ui/core/Grid";

import LogoIcon from "@components/Global/Custom/Logo/LogoIcon";

import Slide from "@material-ui/core/Slide";

const { SITE_NAME, BRAND_NAME } = process.env;

const WebsiteWidgetForm = ({ value }) => {
	const classes = useStyles("Website");

	const [isHovered, setIsHovered] = useState(false);
	const handleMouseEnter = () => setIsHovered(true);
	const handleMouseLeave = () => setIsHovered(false);

	return (
		<>
			<form>
				<Grid container spacing={4}>
					<Grid item xs={12}>
						<div className={classes.widgetFormSubheader}>
							{value === "call" && "We'll call you!"}
							{value === "text" && "Send us a text"}
							{value === "email" && "Send us an email"}
						</div>
						<Box my={2} fontSize={15} color={"grey.600"} lineHeight={1.5}>
							{value === "text" && "We're happy to help."}
							{value === "email" && "Get a quick response via email."}
						</Box>
					</Grid>
					<Grid item xs={6}>
						<Box component="div" mb={1.5} fontWeight={400}>
							First name *
						</Box>

						<TextField
							required
							fullWidth
							variant="outlined"
							size="small"
							autoComplete="given-name"
						/>
					</Grid>
					<Grid item xs={6}>
						<Box component="div" mb={1.5} fontWeight={400}>
							Last name *
						</Box>

						<TextField
							required
							fullWidth
							variant="outlined"
							size="small"
							autoComplete={"family-name"}
						/>
					</Grid>
					{value === "email" && (
						<Grid item xs={12}>
							<Box component="div" mb={1.5} fontWeight={400}>
								Email *
							</Box>
							<TextField
								required
								type="text"
								fullWidth
								variant="outlined"
								size="small"
								autoComplete="email"
							/>
						</Grid>
					)}
					<Grid item xs={12}>
						<Box component="div" mb={1.5} fontWeight={400}>
							Cell phone *
						</Box>
						<TextField
							required
							type="number"
							fullWidth
							variant="outlined"
							size="small"
							autoComplete="tel"
						/>
					</Grid>
					<Grid item xs={12}>
						<Box component="div" mb={1.5} fontWeight={400}>
							Message *
						</Box>
						<TextField
							required
							type="text"
							fullWidth
							variant="outlined"
							size="small"
							multiline
							minRows={2}
							maxRows={2}
						/>
					</Grid>
					<Grid item xs={12}>
						<Box
							fontSize={12}
							lineHeight={1.6}
							color={"#535355"}
							textAlign={"justify"}
						>
							By submitting, you agree to be contacted about your request &
							other information using automated technology. Message frequency
							varies. Msg & data rates may apply. Text STOP to cancel.{" "}
							<Link
								underline="always"
								target="_blank"
								href="https://www.scorpion.co/acceptable-use-policy/"
							>
								Use is subject to terms.
							</Link>
						</Box>
					</Grid>
					<Grid item xs={12}>
						<Box mt={2}>
							<Button
								color="primary"
								size="large"
								variant="contained"
								disableElevation
								fullWidth
								className={classes.widgetButton}
							>
								{value === "call" && "Request call"}
								{value === "text" && "Send"}
								{value === "email" && "Send"}
							</Button>
						</Box>
					</Grid>
					<Grid item xs={12}>
						<Box
							my={2}
							fontSize={12}
							display={"flex"}
							alignItems={"center"}
							justifyContent={"center"}
							style={{ gap: 6 }}
							color={isHovered ? "#222" : "#535355"}
							component={"a"}
							href={`http://${SITE_NAME}.com/pro?utm_source=website&utm_medium=website&utm_content=website&utm_campaign=website`}
							target="_blank"
							onMouseEnter={handleMouseEnter}
							onMouseLeave={handleMouseLeave}
						>
							<LogoIcon
								width={20}
								height="100%"
								filter={isHovered ? "" : "grayscale(100%) opacity(0.7)"}
							/>
							<div>{`Powered By ${BRAND_NAME}`}</div>
						</Box>
					</Grid>
				</Grid>
			</form>
		</>
	);
};

WebsiteWidgetForm.propTypes = {};
export default WebsiteWidgetForm;
